export default __webpack_public_path__ + "static/media/thailand_offshore_wind.f6a83685.png";